module.exports = __webpack_public_path__ + "assets/img/771e3c7c47d6a1c3c687e2d8cb03bf00.svg";